var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carriers-detail"},[_c('el-row',{attrs:{"type":"flex","gutter":20}},[_c('el-col'),_c('el-col'),_c('el-col')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }